// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"24e795ed","453":"1f6bb324","833":"43e0ca47"}[chunkId] + ".chunk.js";
};